import { useContext } from 'react'
import { AccountsContext } from 'contexts/accountsContext'

export const useAccountsContext = () => {
  return useContext(AccountsContext)
}
